import { FC, useContext } from 'react';

import type { NoteEditorBlockDef } from '../../config';

import { NoteBlockWidgetsContext } from './noteBlockWidgets';

type Props = {
  blockId: string;
  def: NoteEditorBlockDef | undefined;
  aside: boolean;
};

export const NoteBlockHost: FC<Props> = ({ blockId, def, aside }) => {
  const widgets = useContext(NoteBlockWidgetsContext);
  if (!widgets) {
    return null;
  }
  if (aside) {
    const Aside = widgets.aside;
    return Aside ? <Aside blockId={blockId} /> : null;
  }
  const kind = def?.Kind.case;
  const Widget = (kind && widgets.byKind[kind]) || widgets.fallback;
  return <Widget blockId={blockId} />;
};

export const NoteLineWidgetHost: FC<{ lineId: string }> = ({ lineId }) => {
  const Widget = useContext(NoteBlockWidgetsContext)?.line;
  return Widget ? <Widget lineId={lineId} /> : null;
};
